/* eslint-disable import/no-extraneous-dependencies */

import { GridColDef } from '@mui/x-data-grid';
import { BrowseView, browseViewColumnAction } from '@pro4-erp/core-web';
import { Edit as EditIcon } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { getValidCertificatesForMe } from '../api/getValidCertificatesForMe';
import { Certificate } from '../types';
import { getBeautifiedLocalDate } from '@/core';

const ValidCertificatsPage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const columns: GridColDef<Certificate>[] = [
    {
      ...browseViewColumnAction({
        field: 'actions',
        headerName: t('Open', { defaultValue: 'Open' }),
        icon: {
          element: <EditIcon />,
          color: 'primary',
        },
        onClick: ({ params }) => navigate(`/client-certificates/${params.id}`),
      }),
      display: 'flex',
    },
    {
      field: 'docReference',
      display: 'flex',
      headerName: t('Title', { defaultValue: 'Title' }).toString(),
      flex: 1.5,
      minWidth: 130,
      disableColumnMenu: true,
    },
    {
      field: 'standardReference',
      display: 'flex',
      headerName: t('Standard', { defaultValue: 'Standart' }).toString(),
      flex: 1.5,
      minWidth: 130,
      disableColumnMenu: true,
    },
    {
      field: 'issueDate',
      display: 'flex',
      headerName: t('CertificateIssueDate', { defaultValue: 'CertificateIssueDate' }).toString(),
      flex: 1.5,
      minWidth: 130,
      disableColumnMenu: true,
      valueGetter(_, row) {
        return row.issueDate ? getBeautifiedLocalDate(row.issueDate) : 'N/A';
      },
    },
    {
      field: 'endDate',
      display: 'flex',
      headerName: t('CertificateEndDate', { defaultValue: 'CertificateEndDate' }).toString(),
      flex: 1.5,
      minWidth: 130,
      disableColumnMenu: true,
      valueGetter(_, row) {
        return row.endDate ? getBeautifiedLocalDate(row.endDate) : 'N/A';
      },
    },
    {
      field: 'firstIssued',
      display: 'flex',
      headerName: t('CertificateFirstIssued', {
        defaultValue: 'CertificateFirstIssued',
      }).toString(),
      flex: 1.5,
      minWidth: 130,
      disableColumnMenu: true,
      valueGetter(_, row) {
        return row.firstIssued ? getBeautifiedLocalDate(row.firstIssued) : 'N/A';
      },
    },
    {
      field: 'status',
      display: 'flex',
      headerName: t('Status', { defaultValue: 'Status' }).toString(),
      flex: 1.5,
      minWidth: 130,
      disableColumnMenu: true,
    },
  ];

  return (
    <BrowseView
      browserViewContainerSx={{
        height: '100vh',
      }}
      columns={columns}
      fetchData={getValidCertificatesForMe}
      toolbar={<BrowseView.Toolbar showSearch showDensityBtn />}
    />
  );
};

export default ValidCertificatsPage;
